import { FC } from "react";
const SwapIcon: FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="12" height="15" viewBox="0 0 12 15" fill="currentcolor" {...props}>
      <path
        d="M3 8.25V2.86875L1.06875 4.8L0 3.75L3.75 0L7.5 3.75L6.43125 4.8L4.5 2.86875V8.25H3ZM8.25 15L4.5 11.25L5.56875 10.2L7.5 12.1313V6.75H9V12.1313L10.9312 10.2L12 11.25L8.25 15Z"
      />
    </svg>
  );
};

export default SwapIcon;
